"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsENV = void 0;
exports.CmsENV = {
    aem: {
        commonPageName: 'common',
        extension: '.cmsfeed.html',
        path: '',
        runtimeMode: true,
        staticSiteMode: false,
    },
    orchestration: {
        commonPageName: 'master',
        extension: '',
        path: '/msapi/idp-content-orchestration/v1',
        runtimeMode: true,
        staticSiteMode: false,
    },
};
//# sourceMappingURL=cms.conf.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/cms-integration/cms.conf.js
// module id = 562
// module chunks = 8